export const USER_ROLES = { USER: "user", ADMIN: "admin" } as const;
export const ADMIN_TABS = {
  PRICING: "pricing",
  CUSTOMERS: "customers",
  FEATURE_REQUESTS: "feature-requests",
} as const;
